import { DwModuleType, DwVersionInfo } from "@devwareapps/devware-cap";

export const angularApplicationVersion: DwVersionInfo = {
    ModuleName: 'Aviator Pro (Angular)',
    ModuleType: DwModuleType.application,
    ProductVersion: '1.2.440',
    PublishDateTime: '10/30/2026 05:16:56 PM'
}
